module.exports = __webpack_public_path__ + "img/media_twiter_nor.7bcfefc5.svg";